import { useCookies } from 'vue3-cookies'
import { sendGetRequest } from "@/helper/requests";
import accounts from "@/urls/accounts";

const HOST_ACCOUNT = process.env.VUE_APP_API_HOST + process.env.VUE_APP_ACCOUNTS_PREFIX
// const HOST_ORGANIZATION = process.env.VUE_APP_API_HOST + process.env.VUE_APP_ORGANIZATION_PREFIX
const { cookies } = useCookies()

function get_domain () {
  /**
   * Получает домен для сохранения cookies
   * @returns {string|null} домен или null
   */
  if (process.env.VUE_APP_COOKIE_DOMAIN !== undefined) {
    return process.env.VUE_APP_COOKIE_DOMAIN
  } else {
    return null
  }
}

function clear_stores () {
  /**
   * Очищает все хранилища браузера, связанные с аутентификацией
   */
  localStorage.removeItem('user-token') // clear your user's token from localstorage
  localStorage.removeItem('isWorker')
  localStorage.removeItem('isStudent')
  localStorage.removeItem('username')
  const domain = get_domain()
  cookies.remove('userMuctr', null, domain)
}

function set_local_store (token, username, uid) {
  /**
   * Сохраняет данные в localStorage
   * @param {string} token - токен пользователя
   * @param {string} username - имя пользователя
   * @param {string} uid - уникальный идентификатор пользователя
   */
  localStorage.setItem('user-token', token)
  localStorage.setItem('username', username)
  localStorage.setItem('user-uid', uid)
}

function set_cookie_store (token, username, uid) {
  /**
   * Сохраняет данные в cookies
   * @param {string} token - токен пользователя
   * @param {string} username - имя пользователя
   * @param {string} uid - уникальный идентификатор пользователя
   */
  cookies.remove('userMuctr', null, get_domain()) // удалим старый
  cookies.set(
    'userMuctr',
    {
      userToken: token,
      userName: username,
      userUid: uid
    },
    '3y',
    null,
    get_domain(),
    null
  )
}

// eslint-disable-next-line
function set_stores (token, username, uid) {
  /**
   * Сохраняет данные во все хранилища браузера
   * @param {string} token - токен пользователя
   * @param {string} username - имя пользователя
   * @param {string} uid - уникальный идентификатор пользователя
   */
  set_cookie_store(token, username, uid)
  set_local_store(token, username, uid)
}

const state = {
  uid: null,
  token: null,
  status: null,
  error: null,
  username: null,
  last_check: null,
  isStudent: false,
  isWorker: null,
  need_change_password: false,
  loading: false,
  password_policy: null
}

// eslint-disable-next-line
const count = 0
const getters = {
  isLoadingAlive: state => state.loading,
  getToken: state => state.token,
  authStatus: state => state.status,
  hasCookie: state => () => {
    return cookies.isKey('userMuctr')
  },
  isCookieLoaded: state => !!state.token,
  isAuthenticate: state => state.token !== null,
  isNeedChangePassword: state => state.need_change_password,
  isCheckExpired: state => () => {
    return (new Date() - state.last_check) > (60 * 1000)
  },
  getPasswordPolicy: state => state.password_policy
}

const actions = {
  loadPasswordPolicy: ({ commit }) => {
    /**
     * Загружает политику паролей
     * @param {Object} context - контекст Vuex
     */
    const url = accounts.PASSWORD_POLICY()
    sendGetRequest(
      url,
      (data, url) => {
        commit('SET_PASSWORD_POLICY', data)
      }
    )
  },
  LOAD_FROM_COOKIE: ({ commit }) => {
    /**
     * Загружает данные аутентификации из cookies
     * @param {Object} context - контекст Vuex
     */
    const userMUCTR = cookies.get('userMuctr')
    if (userMUCTR !== undefined && userMUCTR !== null) {
      commit('SET_TOKEN', userMUCTR.userToken)
      commit('SET_USERNAME', userMUCTR.userName)
      commit('SET_UID', userMUCTR.userUid)
    }
  },
  AUTH_LOGOUT: ({ commit, dispatch }) => {
    /**
     * Выполняет выход пользователя из системы
     * @param {Object} context - контекст Vuex
     * @returns {Promise} промис выполнения выхода
     */
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem('user-token')
      fetch(process.env.VUE_APP_AUTH_URL_LOGOUT, {
        method: 'post',
        headers: {
          Authorization: 'Token ' + token
        }
      })
      commit('AUTH_LOGOUT')
      clear_stores()
      resolve()
    })
  },

  CHECK_TOKEN_ALIVE: ({ commit, dispatch, getters }) => {
    /**
     * Проверяет не протух ли токена аутентификации
     * @param {Object} context - контекст Vuex
     * @returns {Promise} промис проверки токена
     */
    commit('SET_LOADING')
    return new Promise((resolve, reject) => {
      if (getters.hasCookie) {
        if (!getters.isCookieLoaded) {
          dispatch('LOAD_FROM_COOKIE')
        }
        fetch(
                  `${HOST_ACCOUNT}authenticate/token/alive/`,
                  {
                    headers: {
                      'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ token: getters.getToken }),
                    method: 'POST'
                  }
        ).then(resp => {
          if (!resp.ok) {
            clear_stores()
            commit('SET_NOT_LOADING')
            reject(Error(resp.statusText))
          } else {
            return resp.json()
          }
        }).then(json => {
          if (json.alive === false) {
            clear_stores()
            commit('AUTH_LOGOUT').then(() => {
              reject(json)
            })
          } else {
            commit('SET_NEED_CHANGE_PASSWORD', json.need_change_password)
            commit('SET_CHECK_TIME')
            commit('SET_NOT_LOADING')
            resolve()
          }
        }).catch(error => {
          clear_stores()
          commit('SET_NOT_LOADING')
          reject(error)
        })
      } else {
        commit('SET_NOT_LOADING')
        reject(new Error('Does not have cookie'))
      }
    })
  }

}

const mutations = {
  AUTH_LOGOUT: (state) => {
    /**
     * Сбрасывает состояние аутентификации пользователя
     * @param {Object} state - состояние хранилища
     */
    state.status = 'logout'
    state.error = null
    state.isWorker = null
    state.isStudent = false
    state.token = null
    state.uid = null
    state.username = null
    state.last_check = null
    state.need_change_password = false
  },

  SET_CHECK_TIME: (state) => {
    /**
     * Устанавливает время последней проверки токена
     * @param {Object} state - состояние хранилища
     */
    state.last_check = new Date()
  },
  CLEAR_CHECK_TIME: (state) => {
    /**
     * Сбрасывает время последней проверки токена
     * @param {Object} state - состояние хранилища
     */
    state.last_check = null
  },
  SET_NEED_CHANGE_PASSWORD: (state, need_change) => {
    /**
     * Устанавливает флаг необходимости смены пароля
     * @param {Object} state - состояние хранилища
     * @param {boolean} need_change - нужно ли менять пароль
     */
    state.need_change_password = need_change
  },
  CLEAR_ERROR: (state) => {
    /**
     * Очищает поля ошибок
     * @param {Object} state - состояние хранилища
     */
    state.status = ''
    state.error = ''
  },
  SET_TOKEN: (state, token) => {
    /**
     * Устанавливает токен аутентификации
     * @param {Object} state - состояние хранилища
     * @param {string} token - токен пользователя
     */
    state.token = token
    localStorage.setItem('user-token', token)
  },
  SET_USERNAME: (state, username) => {
    /**
     * Устанавливает имя пользователя
     * @param {Object} state - состояние хранилища
     * @param {string} username - имя пользователя
     */
    state.username = username
    localStorage.setItem('username', username)
  },
  SET_UID: (state, uid) => {
    /**
     * Устанавливает уникальный идентификатор пользователя
     * @param {Object} state - состояние хранилища
     * @param {string} uid - уникальный идентификатор
     */
    state.uid = uid
    localStorage.setItem('user-uid', uid)
  },
  SET_LOADING: (state) => {
    /**
     * Включает состояние загрузки
     * @param {Object} state - состояние хранилища
     */
    state.loading = true
  },
  SET_NOT_LOADING: (state) => {
    /**
     * Выключает состояние загрузки
     * @param {Object} state - состояние хранилища
     */
    state.loading = false
  },
  SET_PASSWORD_POLICY: (state, data) => {
    /**
     * Устанавливает политику паролей
     * @param {Object} state - состояние хранилища
     * @param {Object} data - данные политики паролей
     */
    state.password_policy = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
